import React from 'react';
import Svg, { Circle, Path } from 'react-native-svg';
import { Props } from '../../../shared/assets/SvgProps';

import Typography from '@shared/constants/Typography';

const HelpIcon: React.FC<Props> = ({
  width: _width = Typography.width.width16,
  height: _height = Typography.height.height16,
  color = '#FFFFFF',
}) => {
  return (
    <Svg width={_width} height={_height} viewBox="0 0 16 16" fill="none">
      <Path
        d="M8.00016 14.6667C11.6821 14.6667 14.6668 11.6819 14.6668 8C14.6668 4.3181 11.6821 1.33333 8.00016 1.33333C4.31826 1.33333 1.3335 4.3181 1.3335 8C1.3335 11.6819 4.31826 14.6667 8.00016 14.6667Z"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6.06006 6C6.21679 5.55445 6.52616 5.17874 6.93336 4.93942C7.34056 4.70011 7.81932 4.61263 8.28484 4.69247C8.75036 4.77232 9.1726 5.01435 9.47678 5.37569C9.78095 5.73702 9.94743 6.19435 9.94673 6.66667C9.94673 8 7.94673 8.66667 7.94673 8.66667"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Circle cx="8" cy="11.3333" r="0.6" fill={color} />
    </Svg>
  );
};

export default HelpIcon;
